import styles from "./Signup.module.scss";
import React from "react";
import Form from "react-bootstrap/Form";
import {Link} from "react-router";
import useSignup from "./useSignup";
import {GoogleLoginButton} from "../../../common/GoogleLoginButton";
import {TextLineAround} from "../../../common/TextLineAround";

const Signup = () => {
  const {
    t,
    registering,
    handleRegister,
    signInGoogle,
    error,
    email,
    password,
    passwordConfirm,
    updateEmail,
    updatePassword,
    updatePasswordConfirm
  } = useSignup();


  return <div className={styles.container}>
    <div className={styles.textContainer}>
      <div className={styles.noAccount}>{t("title_already_an_account")}</div>

      <Link className={styles.registerBtn} to="/signin">{t("btn_title_signin")}</Link>
    </div>

    <div className={styles.formContainer}>
      <div className={styles.loginForm}>
        <div className={styles.logo}>
          <img src="/android-chrome-192x192.png" alt="Logo"/>

          Jikiwi
        </div>

        <GoogleLoginButton label={t("btn_register_with_google")} onClick={signInGoogle}/>

        <TextLineAround>{t("text_or_register_with_email")}</TextLineAround>

        {error && <div className={styles.error}>{error}</div>}

        <Form onSubmit={handleRegister}>
          <Form.Group className="mb-2" controlId="register-email">
            <Form.Control
              type="text"
              name="register-email"
              value={email}
              onChange={updateEmail}
              placeholder={t("placeholder_email")}
              disabled={registering}
            />
          </Form.Group>
          <Form.Group className="mb-2" controlId="register-password">
            <Form.Control
              type="password"
              name="register-password"
              value={password}
              onChange={updatePassword}
              placeholder={t("placeholder_password")}
              disabled={registering}
              autoComplete="on"
            />
          </Form.Group>
          <Form.Group className="mb-2" controlId="register-password-confirm">
            <Form.Control
              type="password"
              name="register-password-confirm"
              value={passwordConfirm}
              onChange={updatePasswordConfirm}
              placeholder={t("placeholder_password_confirmation")}
              disabled={registering}
              autoComplete="on"
            />
          </Form.Group>

          <button className={styles.submitBtn} type="submit" disabled={registering}>{t("btn_create_account")}</button>
        </Form>
      </div>
    </div>
  </div>;
};

export default Signup;
